module.exports = __webpack_public_path__ + "img/PR.4373bf6a.svg";